var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "faq layout-without-background"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-11 col-md-10 text-md-center"
  }, [_vm.title ? _c('title-section', {
    attrs: {
      "title": _vm.title
    }
  }) : _vm._e(), _vm._v(" "), _vm.subtitle ? _c('subtitle-section', {
    attrs: {
      "subtitle": _vm.subtitle
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-11 col-md-8 text-md-center"
  }, [_c('simple-paragraph', {
    attrs: {
      "paragraph": _vm.paragraph
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-11 col-md-10"
  }, [_c('div', {
    staticClass: "faq-container mt-3"
  }, _vm._l(_vm.faq, function (item, index) {
    return _c('generic-faq', {
      key: index,
      staticClass: "q-and-a",
      attrs: {
        "open": _vm.isOpen === index,
        "question": item.question,
        "answer": item.answer
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.toggleFaq(index);
        }
      }
    });
  }), 1)])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };